export default __webpack_public_path__ + "static/media/92_desktop.3d5cf395.jpg";